import { Component } from '@angular/core';

type ProcessIcon = 'calendar' | 'access' | 'review' | 'camera' | 'report' | 'questions';

interface ProcessStep {
  label: string;
  title: string;
  summary: string;
  icon: ProcessIcon;
  accent: string;
}

@Component({
  selector: 'app-inspection-process-timeline',
  templateUrl: './inspection-process-timeline.component.html',
  styleUrls: ['./inspection-process-timeline.component.scss']
})
export class InspectionProcessTimelineComponent {
  readonly processSteps: ProcessStep[] = [
    {
      label: 'Request',
      title: 'Inspection Need Logged',
      summary: 'GTX confirms the property address, timeline, inspection type, and who needs report access.',
      icon: 'calendar',
      accent: '#004b5d'
    },
    {
      label: 'Access',
      title: 'Scope And Entry Set',
      summary: 'Access notes, utilities, deadlines, and known concerns are organized before the appointment starts.',
      icon: 'access',
      accent: '#0088a8'
    },
    {
      label: 'Review',
      title: 'Visible Systems Checked',
      summary: 'Roland moves through the home methodically, checking major visible systems in practical sequence.',
      icon: 'review',
      accent: '#006d86'
    },
    {
      label: 'Evidence',
      title: 'Photos And Notes Captured',
      summary: 'Findings are documented with photos, locations, limitations, and plain-language context.',
      icon: 'camera',
      accent: '#172226'
    },
    {
      label: 'Report',
      title: 'Report Delivered Clearly',
      summary: 'The finished report groups observations by system so clients can scan priorities and details.',
      icon: 'report',
      accent: '#0088a8'
    },
    {
      label: 'Follow-up',
      title: 'Questions Stay Grounded',
      summary: 'Clients can ask follow-up questions after review, tied back to the documented report language.',
      icon: 'questions',
      accent: '#004b5d'
    }
  ];
}
